export const LOCALIZATION_SLICE_NAME = 'localization';

export const LOCALIZATION_LOAD_TRANSLATION_PREFIX: string = `${LOCALIZATION_SLICE_NAME}/loadTranslation`;
export const LOCALIZATION_LOAD_LANGUAGES_PREFIX: string = `${LOCALIZATION_SLICE_NAME}/loadLanguages`;
export const LOCALIZATION_INITIALIZATION_PREFIX: string = `${LOCALIZATION_SLICE_NAME}/initialization`;
export const LOCALIZATION_SWITCH_LANGUAGE_PREFIX: string = `${LOCALIZATION_SLICE_NAME}/switchLanguage`;
